/* DS Wood — UX polish layer (JS)
   - Global "Glisser" drag cursor on Splide sliders (desktop only)
   - IntersectionObserver-powered fade-up reveal on main sections
   - Performance-minded: single global cursor element, transform-only animations,
     passive listeners, prefers-reduced-motion respected. */

(function () {
  'use strict';

  var prefersReducedMotion = false;
  try {
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var hasHover = false;
  try {
    hasHover = window.matchMedia('(hover: hover)').matches;
  } catch (e) {}

  // ---------- Drag cursor ----------
  function initDragCursor() {
    if (prefersReducedMotion || !hasHover) return;
    if (window.innerWidth <= 768) return;

    var cursor = document.createElement('div');
    cursor.className = 'dsw-drag-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = '<span>Glisser</span>';
    document.body.appendChild(cursor);

    var isDown = false;
    var rafId = null;
    var pendingX = 0;
    var pendingY = 0;

    function applyPos() {
      cursor.style.setProperty('--dsw-cx', (pendingX - 44) + 'px');
      cursor.style.setProperty('--dsw-cy', (pendingY - 44) + 'px');
      rafId = null;
    }

    function onMove(e) {
      pendingX = e.clientX;
      pendingY = e.clientY;
      if (rafId === null) {
        rafId = requestAnimationFrame(applyPos);
      }
    }

    function bindSplide(splide) {
      splide.classList.add('dsw-drag-target');

      splide.addEventListener('mouseenter', function () {
        cursor.classList.add('is-visible');
      });
      splide.addEventListener('mouseleave', function () {
        cursor.classList.remove('is-visible');
        cursor.classList.remove('is-dragging');
        isDown = false;
      });
      splide.addEventListener('mousemove', onMove, { passive: true });
      splide.addEventListener('mousedown', function () {
        isDown = true;
        cursor.classList.add('is-dragging');
      });
    }

    var splides = document.querySelectorAll('.splide');
    for (var i = 0; i < splides.length; i++) {
      var splide = splides[i];
      // Skip sliders that already have their own cursor (Webflow .section-product)
      if (splide.closest('.section-product')) continue;
      bindSplide(splide);
    }

    document.addEventListener('mouseup', function () {
      isDown = false;
      cursor.classList.remove('is-dragging');
    });

    // Observe for dynamically added splides (e.g. late Slater init)
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('splide') && !node.classList.contains('dsw-drag-target') && !node.closest('.section-product')) {
              bindSplide(node);
            }
            if (node.querySelectorAll) {
              var nested = node.querySelectorAll('.splide:not(.dsw-drag-target)');
              for (var q = 0; q < nested.length; q++) {
                if (!nested[q].closest('.section-product')) bindSplide(nested[q]);
              }
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Scroll reveals are handled by animations.js (GSAP ScrollTrigger).
  // ux-polish.js is limited to the drag cursor.

  function init() {
    initDragCursor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
